import { render } from "./ModalMenuDate.vue?vue&type=template&id=0710ac74"
import script from "./ModalMenuDate.vue?vue&type=script&lang=js"
export * from "./ModalMenuDate.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mac/Projects/webshop/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__